import React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import ProductManagementComponent from './components/productManagementComponent/productManagementComponent'
import UnitsPage from './components/rooftopsComponent/unitsComponent/unitsPage'
import WheelsPage from './components/rooftopsComponent/wheelsComponent/wheelsPage'
import AirFlowsPage from './components/rooftopsComponent/airflowsComponent/airflowsPage'
import FansPage from './components/rooftopsComponent/fansComponent/fansPage'
import RooftopsOptionsPage from './components/rooftopsComponent/rooftopsOptionsComponent/rooftopsOptionsPage'
import QmPage from './components/rooftopsComponent/qmComponent/qmPage'
import HomePage from './components/homePage/homePage'
import ControlComponent from './components/productManagementComponent/controlComponent'
import SapDirectPricesPage from './pages/sap-direct'
import { SapDirectNavigationProvider } from './pages/sap-direct/Navigation'

function App() {
    return (
        <Router>
            <SapDirectNavigationProvider>
            <Route path='/' component={HomePage} />
            <Switch>
                {/* Rooftops routes */}
                <Route path='/rooftops/units' component={UnitsPage} />
                <Route path='/rooftops/wheels' component={WheelsPage} />
                <Route path='/rooftops/airFlows' component={AirFlowsPage} />
                <Route path='/rooftops/fans' component={FansPage} />
                <Route path='/rooftops/options' component={RooftopsOptionsPage} />
                <Route path='/rooftops/qm' component={QmPage} />
                <Route path='/rooftops' component={UnitsPage} />

                {/* Control route */}
                <Route path='/control-deprecated' component={ControlComponent} />

                {/* SAP Direct routes */}
                <Route exact path='/sap-direct/:builder(fancoils|drycooler|cdu)' component={SapDirectPricesPage} />
                <Route exact path='/sap-direct' render={() => <Redirect to='/sap-direct/fancoils' />} />
                <Route path='/sap-direct/:builder' render={() => <Redirect to='/sap-direct/fancoils' />} />
                <Route path='/sap-prices' render={() => <Redirect to='/sap-direct/fancoils' />} />

                {/* Product management routes */}
                <Route
                    path='/:product'
                    render={(props) => {
                        const productName = decodeURIComponent(props.match.params.product)
                        if (
                            productName === 'Coolant Distribution Unit' ||
                            productName === 'chillers' ||
                            productName === 'controls'
                        ) {
                            return <ProductManagementComponent {...props} />
                        }
                        return null
                    }}
                />
            </Switch>
            </SapDirectNavigationProvider>
        </Router>
    )
}
export default App
